_(WCC.Settings).defaults({
    maxUserContentImageSize: 512000,
    allowedUploadImageExtensions: ['gif', 'jpeg', 'jpg', 'png'],
});